/**
 * setInterval, кнопка появляется с задержкой
 * count чтобы в бесконечность не ушёл
 */
export function removeSalebot() {
  let count = 0;

  const interval = setInterval(() => {
    count += 1;
    const botBtn = document.querySelector('.salebot_circle_trigger');

    const script = document.querySelector('script#salebot');
    if (script) {
      script.remove();
    }

    if (botBtn) {
      botBtn.remove();
      clearInterval(interval);
    }

    if (count > 200) {
      clearInterval(interval);
    }
  }, 200);
}

export function removeSalebotWidget() {
  let count = 0;

  const interval = setInterval(() => {
    count += 1;

    const scriptWidget = document.querySelector('script#salebot-widget');
    if (scriptWidget) {
      scriptWidget.remove();
    }

    const botWidget = document.querySelector('#sb_widget_parent_frame');
    const botWidgetBg = document.querySelector('.widget_background');
    if (botWidget && botWidgetBg) {
      botWidget.remove();
      botWidgetBg.remove();
      clearInterval(interval);
    }

    if (count > 200) {
      clearInterval(interval);
    }
  }, 300);
}

export default {
  removeSalebot,
  removeSalebotWidget,
};
